export const FETCH_BUSINESS_FUNCTIONS_REQUEST =
  "FETCH_BUSINESS_FUNCTIONS_REQUEST";

export const FETCH_ASSET_GROUPS_REQUEST = "FETCH_ASSET_GROUPS_REQUEST";
